import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { APP_STORE_ID, SITE_URL } from '@/seo/schema/constants';

/** Safari's Smart App Banner; only the diagnostic and dashboard routes mount it. */
export const SmartAppBanner: React.FC = () => {
  const { pathname } = useLocation();
  return (
    <Helmet>
      <meta name="apple-itunes-app" content={`app-id=${APP_STORE_ID}, app-argument=${SITE_URL}${pathname}`} />
    </Helmet>
  );
};
